import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import logError from 'util/misc/log-error';
import CmsImage from './image';
import CmsRichText from './richtext';
import CmsDivider from './divider';
import CmsArticleShort from './article-short';
import CmsTeaser from './teaser';
import CmsIframe from './iframe';
import CmsSection from './section';
import CmsPickers from './pickers';
import CmsTitle from './title';
import CmsPaymentTwint from './payment-twint';
import CmsCountdown from './countdown';
import CmsRegions from './regions';
import CmsColumnWrapper from './column-wrapper';
import CmsVideoColumn from './video-column';
import CmsCardStack from './card-stack';
import CmsFaq from './faq';
import CmsMostPurchasedCumulus from './most-purchased-cumulus';
import CmsFavoriteCategory from './favorite-category';
import CmsFavoriteCategoryWrapper from './favorite-category-wrapper';
import CmsFaqInfo from './faq-info';
import { get, isUndefined } from 'lodash';
import CmsTestimonials from './testimonials';
import CmsProductsSlider from './products-slider';
import StartShoppingButton from './start-shopping-button';
import SectionRightMany from './section-right-many';
import MyMigrosSliders from './mymigros-sliders';

export const pluginList = {
    'article-short': CmsArticleShort,
    'card-stack': CmsCardStack,
    'column-wrapper': CmsColumnWrapper,
    'faq-info': CmsFaqInfo,
    'most-purchased-cumulus': CmsMostPurchasedCumulus,
    'payment-twint': CmsPaymentTwint,
    'video-column': CmsVideoColumn,
    'products-slider': CmsProductsSlider,
    'start-shopping-button': StartShoppingButton,
    'section-right-many': SectionRightMany,
    countdown: CmsCountdown,
    divider: CmsDivider,
    faq: CmsFaq,
    favorite_category: CmsFavoriteCategory,
    favorite_category_wrapper: CmsFavoriteCategoryWrapper,
    iframe: CmsIframe,
    image: CmsImage,
    pickers: CmsPickers,
    regions: CmsRegions,
    richtext: CmsRichText,
    section: CmsSection,
    teaser: CmsTeaser,
    title: CmsTitle,
    testimonials: CmsTestimonials,
    'mymigros-sliders': MyMigrosSliders,

};

export default class Plugin extends Component {
    static propTypes = {
        type: PropTypes.string,
        plugins: PropTypes.array,
        cms: PropTypes.array,
        isCmsEditModeEnabled: PropTypes.bool,
        content: PropTypes.object,
        index: PropTypes.number.isRequired,
        parent: PropTypes.object,
        onEvent: PropTypes.func,
        facet: PropTypes.string,
    };

    componentDidMount() {
        if (this.props.isCmsEditModeEnabled) {
            this.registerToCMS();
        }
    }

    shouldComponentUpdate({ content }) {
        return content !== this.props.content;
    }

    get cmsDataAttrs() {
        if (this.props.isCmsEditModeEnabled) {
            return {
                'data-cms-plugin-edit-helper': true,
                // a safer way to get the plugin name tha apparently is not always sent
                'data-cms-plugin-name': get(this, 'props.cms[1].plugin_name'),
            };
        }

        return {};
    }

    registerToCMS() {
        if (!this.props.cms) {
            logError(`It was impossible to initialise the frontend editing for the cms plugin type="${ this.props.type }"`);
            return;
        }
        const [name, data] = this.props.cms;
        window.CMS.$(this.refs.root).data('cms', [data]);
        window.CMS._plugins.push([name, data]);
        new window.CMS.Plugin(name, data); // eslint-disable-line no-new
    }

    render() {
        const { type, content, cms, plugins, isCmsEditModeEnabled, index, parent, onEvent } = this.props;
        let { facet } = this.props;
        const { cmsDataAttrs } = this;

        if (isUndefined(type) || isCmsEditModeEnabled && !cmsDataAttrs['data-cms-plugin-name']) {
            return null;
        }

        if (parent.type === 'section') {
            facet = parent.sectionFacet;
        }

        if (type === 'countdown' && !facet) {
            facet = 'countdown';
        }

        if (!pluginList[type]) {
            logError(`The plugin "${ type }" has no frontend template, it was not possible to render it`);
            return null;
        }

        return (
            <div ref="root"
                {...cmsDataAttrs}
                className={classnames('cms-placeholder--plugin', cms ? cms[0] : null, `cms-plugin`, `cms-placeholder--plugin__${ type }`, {
                    'cms-placeholder--plugin__is-blocked': isCmsEditModeEnabled,
                })}>
                {React.createElement(pluginList[type], { ...content, plugins, type, cms, index, onEvent, facet })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/plugin.js